import React from "react";
import Head from "next/head";

import {
  capteraCustomerReviews,
  facebookCustomerReviews,
  workspaceCustomerReviews,
} from "@constants/customer-reviews";

import CustomerReviewCard from "components/CustomerReviews/CustomerReviewCard";

export const getStaticProps = async () => {
  const reviews = capteraCustomerReviews
    .map((review) => {
      delete review.title;
      return review;
    })
    .concat(facebookCustomerReviews, workspaceCustomerReviews)
    .sort(() => Math.random() - 0.5);

  return {
    props: { reviews },
  };
};

const Reviews = ({ reviews }) => {
  return (
    <div>
      <Head>
        <meta charSet="utf-8" />
        <title>BoloForms Signature Customer Reviews</title>
        <meta
          name="description"
          content="Electronic signatures refer to signatures in digital format, distinguishing them from traditional handwritten signatures. These digital signatures hold full legal validity for indicating consent or endorsement of document contents. The prevalence of eSignatures is progressively supplanting manual signatures, serving as a versatile method to sign a wide array of documents spanning various sectors on a global scale."
        />
        <meta name="geo.region" content="IN" />
        <meta name="geo.position" content="22.351115;78.667743" />
        <meta name="ICBM" content="22.351115, 78.667743" />
        <meta name="author" content="Boloforms" />
        <meta name="publisher" content="BoloForms" />
        <meta
          name="keywords"
          content="eSignature, electronic signature, digital signature, eSign, eSignatures, electronic signatures, digital signatures, eSignature software, electronic signature software, digital signature software, eSignature solution, electronic signature solution, digital signature solution, eSignature app, electronic signature app, digital signature app, eSignature platform, electronic signature platform, digital signature platform, eSignature service, electronic signature service, digital signature service, eSignature tool, electronic signature tool, digital signature tool, eSignature online, electronic signature online, digital signature online, eSignature solution online, electronic signature solution online, digital signature solution online, eSignature software online, electronic signature software online, digital signature software online, eSignature platform online, electronic signature platform online, digital signature platform online"
        />
        <meta
          property="og:url"
          content="https://www.bolosign.com/signature/reviews/"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="BoloForms Signature Customer Reviews"
        />
        <meta name="twitter:site" content="@boloforms" />
        <meta
          property="twitter:url"
          content="https://www.bolosign.com/signature/reviews/"
        />
        <meta
          name="twitter:title"
          content="BoloForms Signature Customer Reviews"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:creator" content="@boloforms" />
        <meta property="twitter:domain" content="https://bolosign.com" />
        <meta name="twitter:description" content="" />
        <meta property="og:description" content="" />
        <meta
          name="robots"
          content="noindex, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
        />
        <link
          rel="canonical"
          href="https://www.bolosign.com/signature/reviews/"
        />
      </Head>

      <div className="text-center">
        <h3 className="text-primary">Testimonials</h3>

        <h1 className="font-bold text-4xl sm:text-5xl lg:text-6xl mxl:text-7xl mt-5">
          Over 1,00,000+ people trust us
        </h1>

        <p className="text-lg sm:text-xl max-w-[500px] mx-auto mt-10">
          Unlimited signatures, templates, forms, and team members. One fixed
          price. No extra charges, ever.
        </p>
      </div>

      <div className="mt-20 max-w-sm sm:max-w-3xl lg:max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row gap-8">
          <div className="sm:w-1/2 lg:w-8/12 xl:w-1/2">
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="w-full xl:w-1/2">
                <div className="flex flex-col gap-8">
                  {reviews.slice(0, 7).map((review, index) => (
                    <CustomerReviewCard
                      key={index}
                      variant="centralized"
                      {...review}
                    />
                  ))}
                </div>
              </div>

              <div className="w-full xl:w-1/2">
                <div className="flex flex-col gap-8">
                  {reviews.slice(7, 14).map((review, index) => (
                    <CustomerReviewCard
                      key={index}
                      variant="centralized"
                      {...review}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="sm:w-1/2 lg:w-4/12 xl:w-1/2">
            <div className="flex flex-col xl:flex-row gap-8">
              <div className="w-full xl:w-1/2 flex flex-col gap-8">
                {reviews.slice(14, 21).map((review, index) => (
                  <CustomerReviewCard
                    key={index}
                    variant="centralized"
                    {...review}
                  />
                ))}
              </div>

              <div className="w-full sm:1/2 lg:hidden xl:flex xl:w-1/2 flex flex-col gap-8">
                {reviews.slice(21, 28).map((review, index) => (
                  <CustomerReviewCard
                    key={index}
                    variant="centralized"
                    {...review}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
